module.exports = __webpack_public_path__ + "static/media/logo.fe268401.svg";